import { render } from "./subirArchivos.vue?vue&type=template&id=5f46a858&scoped=true"
import script from "./subirArchivos.vue?vue&type=script&lang=js"
export * from "./subirArchivos.vue?vue&type=script&lang=js"

import "./subirArchivos.vue?vue&type=style&index=0&id=5f46a858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f46a858"]])

export default __exports__